import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { cpf, cnpj } from "cpf-cnpj-validator";
import { TypeCreateClient } from "src/app/core/enum/type-create-client.enum";
import { ApiServiceClient } from "src/app/core/services/client.service";

@Component({
  selector: "new-propose-dialog",
  templateUrl: "new-propose-dialog.html",
  styleUrls: ["./new-propose-dialog.scss"]
})
export class NewProposeDialog implements OnInit {
  document: string;
  typeError: {
    existClient?: boolean;
    existClientOtherBase?: boolean;
    notExistClient?: boolean;
  } = {
    existClient: false,
    existClientOtherBase: false,
    notExistClient: false
  };

  clientData: any;

  constructor(
    private dialogRef: MatDialogRef<NewProposeDialog>,
    private apiServiceClient: ApiServiceClient,
    private router: Router
  ) {}

  @Input() titleText: string;
  @Input() text: string;
  @Input() confirmButtonText: string;
  @Input() cancelButtonText: string;
  @Output() callbackConfirm = new EventEmitter<string>();

  ngOnInit() {}

  confirm() {
    this.callbackConfirm.emit();
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  formatDocumentType(type: string) {
    if (cpf.isValid(this.document)) return TypeCreateClient.CPF;
    if (cnpj.isValid(this.document)) return TypeCreateClient.CNPJ;
    return;
  }

  newPropose() {
    this.dialogRef.close();
    this.router.navigate([`groups-products-list/${this.clientData.uuid}`], {
      queryParams: { type: this.formatDocumentType(this.document), return: "client-form" }
    });
  }

  createClient() {
    let cnpjValidate = this.document.replace(/\D+/g, "");
    this.dialogRef.close();
    this.router.navigate([`users/form/client-form`], {
      queryParams: { type: this.formatDocumentType(this.document), document: cnpjValidate }
    });
  }

  verifyDocumentExists() {
    let cnpjValidate = this.document.replace(/\D+/g, "");
    this.apiServiceClient.getClientByDocument(cnpjValidate).subscribe({
      next: res => {
        this.clientData = res;
        this.typeError = {};
        this.typeError.existClient = true;
      },
      error: error => {
        if (error && error.message === "Client not found") {
          this.typeError = {};
          this.typeError.notExistClient = true;
        }
        if (error && error.errors && error.errors.cnpj && error.errors.cnpj.NotExists) {
          this.typeError = {};
          this.typeError.existClientOtherBase = true;
        }
      }
    });
  }
}
